import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/pinterest-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 80V432C448 458.5 426.5 480 400 480H154.4C164.2 463.6 176.8 440 181.8 420.7 184.8 409.2 197.1 362.3 197.1 362.3 205.1 377.6 228.5 390.5 253.4 390.5 327.5 390.5 380.8 322.4 380.8 237.8 380.8 156.7 314.6 96 229.4 96 123.4 96 67.2 167.1 67.2 244.6 67.2 280.6 86.4 325.4 117 339.7 121.7 341.9 124.1 340.9 125.2 336.4 126 333 130.2 316.3 132 308.6 132.6 306.1 132.3 304 130.3 301.6 120.2 289.3 112 266.7 112 245.6 112 191.4 153 139 222.9 139 283.2 139 325.5 180.1 325.5 238.9 325.5 305.3 292 351.3 248.3 351.3 224.2 351.3 206.2 331.4 211.9 306.9 218.8 277.7 232.2 246.2 232.2 225.1 232.2 172.1 156.7 179.4 156.7 250.1 156.7 271.8 164 286.6 164 286.6 132.6 419.4 127.9 421.1 134.4 479.2L136.6 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/pinterest-square.js
// module id = sbPx
// module chunks = 144